<template>
  <div class="common-card collection-list-wrapper">
    <modal-filter
      :filter_customer_id.sync="filter_customer_id"
      :filter_invoice_id.sync="filter_invoice_id"
      :filter_voucher_status_id.sync="filter_voucher_status_id"

      :invoiceOptions="invoiceOptions"
      :customerOptions="customerOptions"
      :voucherStatusOptions="voucherStatusOptions"
      @refetch-data="refetchData"
    />
  

    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
            <b-form-input
              v-model="searchQuery"
              class="search-form mb-1 mb-sm-0 ml-sm-1"
              placeholder="搜尋..."
            />
          </div>
        </div>
          <div class="d-flex flex-wrap mobile-w100 mt-1 mt-lg-0">
     
            <b-button
              variant="primary"
              class="mobile-w100 mb-1 mb-sm-0 mr-sm-1"
              @click="$bvModal.show('modal-filter4')"
              ><feather-icon
                class="mr-1"
                icon="filterIcon"
                size="18"
              ></feather-icon
              >篩選</b-button
            >
            <b-button class="mobile-w100" :to="{ name: 'coupon-collection-create' }" v-if="ability.can('create', 'collection_voucher')">
              <feather-icon
                class="mr-1"
                icon="plusIcon"
                size="18"
              ></feather-icon
              >新增記錄</b-button
            >
          </div>
      </div>
    </b-card>
    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refCollectionListTable"
          class="position-relative"
          :items="fetchCollections"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >

          <template #cell(invoice_id)="data">
            {{ getInvoiceNumber(data.item.invoice_id) }}
          </template>

          <template #cell(name_cn)="data">
            {{ getCustomerField(data.item.customer_id, 'name_cn') }}
          </template>
          <template #cell(name)="data">
            {{ getCustomerField(data.item.customer_id, 'name') }}
          </template>
          <template #cell(phone)="data">
            {{ getCustomerField(data.item.customer_id, 'phone') }}
          </template>

          <template #cell(voucher_status_id)="data">
            {{ getVoucherStatus(data.item.voucher_status_id) }}
          </template>

          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                collectionList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
          
              <b-dropdown-item
                v-if="ability.can('update', 'collection_voucher')"
                :to="{
                  name: 'coupon-collection-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'collection_voucher')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>

            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useCollectionsList from "./useCollectionsList";
import collectionStoreModule from "../collectionStoreModule";
import ModalFilter from "../modal/ModalFilter";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ModalFilter,
  },
  data() {
    return {
    };
  },
  methods: {
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("collection/deleteCollection", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    getInvoiceNumber(invoiceId) {
      if (!invoiceId || !this.invoiceOptions || !this.invoiceOptions.length) return '';
      const invoice = this.invoiceOptions.find(ele => ele.id === invoiceId);
      return invoice ? invoice.invoice_number : '';
    },
    
    getCustomerField(customerId, field) {
      if (!customerId || !this.customerOptions || !this.customerOptions.length) return '';
      const customer = this.customerOptions.find(ele => ele.id === customerId);
      return customer ? customer[field] : '';
    },
    
    getVoucherStatus(statusId) {
      if (!statusId || !this.voucherStatusOptions || !this.voucherStatusOptions.length) return '';
      const status = this.voucherStatusOptions.find(ele => ele.id === statusId);
      return status ? status.name : '';
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "collection";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, collectionStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });


    const {
      fetchCollections,
      tableColumns,
      perPage,
      totalRow,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      dataMeta,
      collectionList,
      refCollectionListTable,
      ability,
      refetchData,
      filter_invoice_id,
      filter_customer_id,
      filter_voucher_status_id,
      invoiceOptions,
      customerOptions,
      voucherStatusOptions,
    } = useCollectionsList();

    return {
      fetchCollections,
      tableColumns,
      perPage,
      totalRow,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      dataMeta,
      collectionList,
      refCollectionListTable,
      ability,
      refetchData,
      filter_invoice_id,
      filter_customer_id,
      filter_voucher_status_id,
      invoiceOptions,
      customerOptions,
      voucherStatusOptions,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";

@media (min-width: 540px) {
  .collection-list-wrapper {
    .sticky-column {
      &:nth-child(2) {
        width: 180px!important;
        min-width: 180px!important;
        max-width: 180px!important;
      }
      &:nth-child(3) {
        left: 300px;
      }
    }
  }
}
</style>
    